import { createTheme } from '@mui/material/styles';
import { remCalc } from '../../utils/remCalc';
import breakpoints from '../../utils/breakpoints';

const theme = createTheme({
	breakpoints: breakpoints,
});

const styles = {
	components: {
		MuiContainer: {
			styleOverrides: {
				root: {
					'&.InlineVideo-root': {
						paddingTop: remCalc(20),
						paddingBottom: remCalc(20),
						[theme.breakpoints.up('sm')]: {
							paddingTop: remCalc(50),
							paddingBottom: remCalc(50),
						},
						
						'.InlineVideo-thumbnailContainer': {
							position: 'relative',
							overflow: 'hidden',
							width: '100%',
							height: '100%',
							borderRadius: '11px',
							cursor: 'pointer',
							[theme.breakpoints.down('md')]: {
								paddingLeft: '0 !important',
								paddingRight: '0 !important',
							},
							'*': {
								borderRadius: '11px',
							},
						},
						
						'.InlineVideo-buttonContainer': {
							zIndex: 2,
							position: 'absolute',
							marginTop: '-18px',
							transform: 'translateY(-100%)',
							right: remCalc(40),
							[theme.breakpoints.up('sm')]: {
								right: remCalc(16),
							},
							button: {
								margin: 0,
								padding: 0,
							}
						},

						'.InlineVideo-videoLoop': {
							video: {
								width: '100%',
								height: '100%',
							}
						}
					},
				},
			},
		},
	},
}

export default styles;